import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import { fetchAndSetFlashMessage } from '../../../Helpers/fetcher'

const InstructionCard = ({ app }) => {
    const [msg, setMsg] = useState()
    useEffect(() => {
        fetchAndSetFlashMessage(
            app.apiPath,
            msg => msg.moduleName === "prompt_instructions" && msg.action === "add",
            msg => setMsg(msg)
        );
    }, [])
    return (
        <Card className="h-100">
            <Card.Header className="sub-header">Instructions</Card.Header>
            <Card.Body style={{ overflowY: 'auto', maxHeight: '100vh' }}>
                <pre style={{ whiteSpace: 'pre-wrap', fontSize: '1.1rem', fontWeight: '500' }} >
                    {msg}
                </pre>
            </Card.Body>
        </Card>
    )
}

export default InstructionCard
